import React, { PureComponent } from "react";
import Loader from "react-loaders";
import { maxBy, orderBy } from "lodash";
import SweetAlert from "sweetalert-react";

import TotalProductionCost from "../components/operations/decisions/total-production-cost";
import InHouseProduction from "../components/operations/decisions/in-house-production";
import {
  getRequest,
  batchRequest,
  postRequest,
  deleteRequest,
  patchRequest,
} from "../api/ApiService";
import { decimalsRound, logError } from "../services/utils";
import RoleButtons from "../components/role-buttons";
import Auth from "../routes/Auth";
import Teams from "api/Teams";
import SubmitDecisionsButton from "../components/ui-building-blocks/buttons/submit-decisions";
import ButtonsGroup from "../components/operations/decisions/buttons-group";
import {
  getSubmissionRequest,
  handleSubmission,
  submitDecisions,
  incrementUnacceptedDecisions,
  decrementUnacceptedDecisions,
  updateSubmissionFromJournal
} from "../api/SubmitDecisions";
import Styled from "components/operations/style";
import { view } from "@risingstack/react-easy-state";
import LastStepModal from "../components/get-started/last-step";
import EventEmitter from "../services/event-emitter";
//import GoogleMapReact from "google-map-react";
import IconTableHelp from "./assets/icon-table-help.svg";
import SelectFacilityPopup from "../components/operations/decisions/select-facility";
import DistributionCentersPopup from "../components/operations/decisions/distribution-centers";

import MapImage from '../containers/assets/new-map-without-buttons.png';
import MapIcon1 from '../containers/assets/map-icon1.png';
import MapIcon2 from '../containers/assets/map-icon2.png';
import MapIcon3 from '../containers/assets/map-icon3.png';
import MapIcon4 from '../containers/assets/map-icon4.png';
import MapIcon5 from '../containers/assets/map-icon5.png';
import MapIcon6 from '../containers/assets/map-icon6.png';
import MapIcon7 from '../containers/assets/map-icon7.png';
import MapIcon8 from '../containers/assets/map-icon8.png';

import MapLines1 from '../containers/assets/map-lines1.png';
import MapLines2 from '../containers/assets/map-lines2.png';
import MapLines3 from '../containers/assets/map-lines3.png';

import TooltipImage1 from '../containers/assets/tooltip-image1.png';

import MapHoverIcon1 from '../containers/assets/map-hover-icon1.png';
import MapHoverIcon2 from '../containers/assets/map-hover-icon2.png';
import MapHoverIcon3 from '../containers/assets/map-hover-icon3.png';
import MapHoverIcon4 from '../containers/assets/map-hover-icon4.png';

import SmallCheckbox from '../containers/assets/small-checkbox.png';
import SmallCheckboxActive from '../containers/assets/small-checkbox-active.png';

import { numberFormat } from '../components/analysis/format';
import SuccessAlert from "../components/alerts/success";
import Fragment from "react-dot-fragment";

import DecisionsAlert from "../components/alerts/decisions";

const tooltipsPositions = {
  1: [205, 255],
  2: [145, 260],
  3: [5, 130],
  4: [250, 138],
  5: [5, 195],
  6: [135, 88],
  7: [135, 40],
  8: [177, 62],
  9: [205, 130],
  10: [205, 130],
  11: [160, 70],
  12: [40, 110],
  13: [95, 128],
  14: [55, 150],
};
const customersLocations = {
  1: 'Jackson, AL',
  2: 'Garland, TX',
  3: 'Happy Valley, OR',
  4: 'Detroit, MI',
  5: 'Fremont, CA',
  6: 'Tulsa, OK',
  7: 'Ellsworth, KS',
  8: 'Springfield, MO',
  9: 'Littleton, CO',
  10: 'Sheboygan, WI',
  11: 'Henrietta, NY',
  12: 'Albuquerque, NM',
  13: 'Jeffersontown, KY',
  14: 'Dyersburg, TN',
};

class OperationsDecisions extends PureComponent {
  constructor(props) {
    super(props);

    const { roundInUrl, currentRound, rounds } = props;

    const role = Auth.getRole();
    const hasAccess = role === "CEO" || role === "OP";
    const isOwnRole = role === "OP";

    this.state = {
      loaded: false,
      total_spending: 0,
      machines_costs: 0,
      product_manufactures: [],
      team_machines: [],
      factory_ppe: 0,
      ppe_costs: 0,
      products: [],
      isOwnRole,
      hasAccess,
      submission_data: {
        op: {
          date: "N/A",
          unaccepted: 0
        }
      },
      original_machines_costs: 0,
      production_costs: 0,
      cash_payments_prior_round_purchases: 0,
      capital_exp_sales: 0,
      facility_costs: 0,
      submitDecisionsLoading: true,
      loadingFactory: false,
      machines: [],
      factories: [],
      hours: [],
      roundInUrl,
      currentRound,
      rounds,
      selectFacilityPopupShown: false,
      facilityPopup: null,
      showDistributionCenters: false,
      canSelectDistributionCenters: false,
      activeDistributionCenter: 0,
      distribution: null,
      leadTimes: [],
      leadTimesLoaded: false,
      tooltip1: false,
      openingDistributionCenter: false,
      players: [],
      distributionCenter: 0,
      distributionCenterId: 0,
      cash_payment_for_distribution_center: 0,
      distributionCentersInfo: [],
      distributionCenterPPE: 0,
      tooltipCustomerName: null,
      tooltipCustomerDemand: null,
      customerDemands: [],
      showChangeLocationAlert: false,
      movingDistributionCenter: false,
      isPreChecked: false,
      successMessage: null,
      isInfoAlertVisible: false,
      infoAlertTitle: '',
      infoAlertText: '',
      selectDistributionCenterFacilityPopup: false,
      showDeselectLocationAlert: false
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  showInfoAlert = (infoToShow) => {
    let title, text;
    if (infoToShow === 'Facility') {
      title = 'Facility';
      text = 'Refers to the building where the image sensors are manufactured. There’s only 1 facility.';
    } else if (infoToShow === 'Distribution Center') {
      title = 'Distribution Center';
      text = 'Refers to the building used to store, manage, and ship goods closer to customers.';
    } else if (infoToShow === 'Machine Utilization') {
      title = 'Machine Utilization';
      text = 'Machine utilization measures the machine hours used for production relative to the annual maximum of 8,736 hours. Even at 25% utilization, you could max out production if your product launches later in the year. For example, a Q4 release limits machine use to 90 out of 360 days.';
    }

    this.setState({
      isInfoAlertVisible: true,
      infoAlertTitle: title,
      infoAlertText: text
    });
  };

  hideInfoAlert = () => {
    this.setState({
      isInfoAlertVisible: false
    });
  };

  showSuccessMessage = successMessage => {
    this.setState({
      successMessage,
    }, () => {
      this.hideSuccessMessage();
    });
  }

  hideSuccessMessage = () => {
    setTimeout(() => {
      this.setState({
        successMessage: null,
      });
    }, 5000);
  }

  showCustomerTooltip = tooltipCustomerName => () => {
    const { customerDemands } = this.state;
    const customerDemand = customerDemands.find(i => Number(i.customer) === Number(tooltipCustomerName));
    const tooltipCustomerDemand = customerDemand ? numberFormat(Number(customerDemand.demand)) : 0;

    this.setState({
      tooltipCustomerName,
      tooltipCustomerDemand,
    });
  }

  showChangeLocationAlert = () => {
    this.setState({
      showChangeLocationAlert: true,
    });
  }

  hideChangeLocationAlert = () => {
    this.setState({
      showChangeLocationAlert: false,
    });
  }

  showDeselectLocationAlert = () => {
    this.setState({
      showDeselectLocationAlert: true,
    });
  }

  hideDeselectLocationAlert = () => {
    this.setState({
      showDeselectLocationAlert: false,
    });
  }

  hideCustomerTooltip = () => {
    this.setState({
      tooltipCustomerName: null,
      tooltipCustomerDemand: null,
    });
  }

  showTooltip1 = () => {
    this.setState({
      tooltip1: true,
    });
  }

  hideTooltip1 = () => {
    this.setState({
      tooltip1: false,
    });
  }

  showSelectDistributionCenterFacilityPopup = () => {
    this.setState({
      selectDistributionCenterFacilityPopup: true,
    });
  }

  hideSelectDistributionCenterFacilityPopup = () => {
    this.setState({
      selectDistributionCenterFacilityPopup: false,
    });
  }

  setPopupRef = ref => {
    this.setState({
      facilityPopup: ref,
    });
  }

  showDistributionCenters = () => {
    this.setState({
      showDistributionCenters: true,
    });
  }

  hideDistributionCenters = () => {
    this.setState({
      showDistributionCenters: false,
    });
  }

  cancelDistributionCenter = () => {
    this.setState({
      activeDistributionCenter: 0,
      distribution: null,
      leadTimes: [],
      leadTimesLoaded: false,
    });
  }

  unselectDistributionCenter = () => {
    this.setState({
      activeDistributionCenter: 0,
      distribution: null,
      selectDistributionCenterFacilityPopup: false
    });
  }

  selectDistributionCenter = activeDistributionCenter => {
    console.log('inside selectDistributionCenter');
    const { distributionCentersInfo } = this.state;
    const distribution = distributionCentersInfo.find(i => Number(i.type) === activeDistributionCenter);

    this.setState({
      activeDistributionCenter,
      distribution,
    });
  }

  calculateDistance = () => {
    const { activeDistributionCenter } = this.state;

    getRequest(`${process.env.REACT_APP_API_URL}v2/distributions/lead-times/`)
      .then(res => {
        const leadTimes = res.body.results.filter(i => Number(i.distribution_center) === activeDistributionCenter);

        this.setState({
          canSelectDistributionCenters: false,
          leadTimes,
          leadTimesLoaded: true,
        });
      })
      .catch(err => { });
  }

  canSelectDistributionCenters = () => {
    this.setState({
      showDistributionCenters: false,
      canSelectDistributionCenters: true,
      selectDistributionCenterFacilityPopup: false,
      activeDistributionCenter: 0,
      distribution: null,
      leadTimes: [],
      leadTimesLoaded: false,
    });
  }

  reloadRole = () => {
    const role = Auth.getRole();
    const hasAccess = role === "CEO" || role === "OP";
    const isOwnRole = role === "OP";

    this.setState({
      hasAccess,
      isOwnRole
    });
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.state.roundInUrl !== nextProps.roundInUrl ||
      this.state.currentRound !== nextProps.currentRound ||
      (this.state.rounds.length === 0 && nextProps.rounds.length !== 0)
    ) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl,
          currentRound: nextProps.currentRound,
          rounds: nextProps.rounds
        },
        () => {
          this.fetchData();
          this.reloadRole();
        }
      );
    }
  }

  componentDidMount() {
    this.eventemitter.on("update-submit-decisions", this.updateSubmitDecisions);
    this.fetchData();
  }

  componentWillUnmount() {
    this.eventemitter.off("update-submit-decisions", this.updateSubmitDecisions);
  }

  updateSubmitDecisions = () => {
    const { roundInUrl, currentRound } = this.state;

    updateSubmissionFromJournal(
      ['op'],
      roundInUrl !== null ? roundInUrl : currentRound,
      submission_data => {
        this.setState({
          submission_data,
        });
      }
    );
  }

  updateFactoryPPE = round_number => {
    const temporaryUser = Auth.getTemporaryUser();
    const additionalQuery = temporaryUser ? `&team_id=${temporaryUser.team_id}` : "";

    getRequest(
      `${process.env.REACT_APP_API_URL}team/page/operations/?round_number=${round_number}${additionalQuery}`
    )
      .then(res => {
        const factory_ppe = res.body.team.facility_costs;

        if (factory_ppe === 0 && round_number > 1) {
          this.updateFactoryPPE(round_number - 1);
        }

        if (factory_ppe > 0) {
          this.setState({
            factory_ppe
          });
        }
      })
      .catch(err => { });
  };

  fetchData = () => {
    const { rounds } = this.props;
    const { roundInUrl, currentRound } = this.state;
    const round_number = roundInUrl !== null ? roundInUrl : currentRound;
    const temporaryUser = Auth.getTemporaryUser();
    const additionalQuery = temporaryUser ? `&team_id=${temporaryUser.team_id}` : "";
    const additionalQuery2 =
      temporaryUser ? `?team_id=${temporaryUser.team_id}` : "";

    const joinRequest = batchRequest([
      `${process.env.REACT_APP_API_URL}team/page/operations/?round_number=${round_number}${additionalQuery}`,
      ...getSubmissionRequest(
        ["op"],
        round_number,
        false,
        temporaryUser,
      ),
      `${process.env.REACT_APP_API_URL}team/product_manufactures/?round_number=${round_number}${additionalQuery}`,
      `${process.env.REACT_APP_API_URL}team/machines/?round_number=${round_number}${additionalQuery}`,
      `${process.env.REACT_APP_API_URL}team/factories/${additionalQuery2}`,
      `${process.env.REACT_APP_API_URL}team/hours/?round_number=${round_number}${additionalQuery}`,
      `${process.env.REACT_APP_API_URL}v2/games/teamplayers/`,
      `${process.env.REACT_APP_API_URL}v2/distributions/team-centers/`,
      `${process.env.REACT_APP_API_URL}v2/distributions/centers/`,
      `${process.env.REACT_APP_API_URL}team/ppes/?round_number=${round_number}${additionalQuery}`,
      `${process.env.REACT_APP_API_URL}static/customer_demand/`,
      `${process.env.REACT_APP_API_URL}games/${Auth.getGameId()}/journal/?round_number=${round_number}${temporaryUser ? `&team_id=${temporaryUser.team_id}` : ''}`,
    ]);

    joinRequest
      .then(res => {
        if (
          res[0].statusCode !== 200 ||
          res[3].statusCode !== 200 ||
          res[4].statusCode !== 200 ||
          res[5].statusCode !== 200 ||
          res[6].statusCode !== 200
        ) {
          throw res;
        }
        const operations = res[0].body;
        const submission_data =
          res[1].statusCode === 200
            ? handleSubmission(
              ["op"],
              [res[1].body, res[2].body]
            )
            : this.state.submission_data;
        const product_manufactures = res[3].body;
        const team_machines = res[4].body;
        const factories = res[5].body;
        const hours = res[6].body;
        const { products, team } = operations;

        const playersRaw = res[7].body;
        const players = playersRaw.results;

        const round = rounds.find(i => Number(i.number) === Number(round_number));
        const roundId = round ? Number(round.id) : 0;
        const teamId = Number(Auth.getTeamId());

        const previousRoundsIds = rounds.filter(i => Number(i.number) >= 2 && Number(i.number) <= Number(round_number)).map(i => i.id);

        const distributionCentersRaw = orderBy(
          res[8].body.results.filter(i => Number(i.team) === teamId && previousRoundsIds.includes(Number(i.round))),
          'number',
          ['desc']
        );
        const distributionCenterObj = distributionCentersRaw.length > 0 ? distributionCentersRaw[0] : null;
        const distributionCenter = distributionCenterObj ? Number(distributionCenterObj.distribution_center) : 0;
        const distributionCenterId = distributionCenterObj ? Number(distributionCenterObj.id) : 0;

        const {
          production_costs,
          cash_payments_prior_round_purchases,
          facility_costs,
          capital_exp_sales,
          ppe_costs,
          overall_machine_utilization,
          machines,
          distribution_centers,
        } = team;

        const distributionCenterCost = distribution_centers
          ? distribution_centers.find(i => (
            Number(i.type) === distributionCenter
            && Number(i.round) === roundId
          ))
          : null;
        const cash_payment_for_distribution_center = distributionCenterCost ? Number(distributionCenterCost.cost) : 0;

        const machines_costs = team.machines_costs ? team.machines_costs : 0;
        let original_machines_costs = 0;
        machines.forEach(machine => {
          original_machines_costs += machine.machine_costs;
        });
        const total_spending =
          original_machines_costs +
          production_costs -
          facility_costs +
          capital_exp_sales +
          cash_payments_prior_round_purchases +
          cash_payment_for_distribution_center;
        const factory_ppe = facility_costs;
        if (factory_ppe === 0 && round_number > 1 && !temporaryUser) {
          this.updateFactoryPPE(round_number - 1);
        }

        const distributionCentersInfoRaw = res[9].body;
        const distributionCentersInfo = distributionCentersInfoRaw.results;

        const ppesRaw = res[10].body;
        const distributionCenterPPE = ppesRaw.find(i => (
          Number(i.team) === teamId
          && Number(i.round) === roundId
          && i.content_type === 'team distribution center'
        ));

        const customerDemandsRaw = res[11].body;
        const customerDemands = customerDemandsRaw.filter(i => Number(i.round_number) === round_number);

        const journal = res[12].body;
        let isPreChecked = true;
        let historyOperations = journal.filter(i => (
          i.path.startsWith('/api/team/factories/')
          || i.path.startsWith('/api/team/machines/')
          || i.path.startsWith('/api/team/product_manufactures/')
          || i.path.startsWith('/api/teams/submit_operations/'))
        );

        historyOperations = historyOperations.sort((a, b) => {
          const dateA = new Date(a.requested_at);
          const dateB = new Date(b.requested_at);

          return dateB - dateA;
        });

        if (!historyOperations.length || historyOperations[0].path !== '/api/teams/submit_operations/' || (historyOperations[0].status_code !== 200 && historyOperations[0].status_code !== 201))
          isPreChecked = false;

        this.setState({
          total_spending,
          machines_costs: Math.abs(machines_costs),
          factory_ppe,
          ppe_costs,
          products,
          submission_data,
          product_manufactures,
          team_machines,
          overall_machine_utilization,
          capital_exp_sales,
          original_machines_costs,
          production_costs,
          cash_payments_prior_round_purchases,
          cash_payment_for_distribution_center,
          facility_costs,
          machines,
          factories,
          hours,
          submitDecisionsLoading: false,
          loaded: true,
          players,
          distributionCenter,
          distributionCenterId,
          distributionCentersInfo,
          distributionCenterPPE: distributionCenterPPE ? Number(distributionCenterPPE.value) : 0,
          customerDemands,
          movingDistributionCenter: false,
          isPreChecked,
        });
      })
      .catch(err => {
        logError(err, "OperationsDecisions", "fetchData");
      });
  };

  get capitalExpenditures() {
    const { factory_ppe, machines } = this.state;
    let result = {
      "Production Facility": factory_ppe
    };

    result["Production Line 1"] = 0;
    result["Production Line 2"] = 0;
    result["Production Line 3"] = 0;
    result["Production Line 4"] = 0;

    machines.forEach(machine => {
      result[`Production Line ${machine.machine}`] = Math.abs(
        machine.machine_costs
      );
    });

    return result;
  }

  get humanUtility() {
    const { products } = this.state;
    const obj = maxBy(products, "human_utility");

    return obj ? obj.human_utility : 0;
  }

  get machineUtility() {
    const { team_machines, hours } = this.state;
    const machinesCount =
      team_machines && team_machines.length > 0 ? team_machines.length : 0;
    const hoursSum = hours && hours.length > 0 ? hours.length : 0;

    return machinesCount > 0 ? hoursSum / (machinesCount * 8.736) : 0;
  }

  submitDecisions = () => {
    this.setState({
      submitDecisionsLoading: true
    });

    submitDecisions("operations", this.state.roundInUrl || this.state.currentRound, () => {
      this.fetchData();
    });
  };

  get showActionButtons() {
    const { hasAccess, roundInUrl, currentRound, rounds } = this.state;
    const { roundShouldBeFinished } = this.props;

    if (hasAccess === false) {
      return false;
    }

    if (roundShouldBeFinished === true) {
      return false;
    }

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      return false;
    }

    const round = rounds.find(i => i.number === currentRound);

    if (!round) {
      return false;
    }

    return round.is_started === true && round.is_finished === false;
  }

  createFactory = () => {
    return postRequest(`${process.env.REACT_APP_API_URL}team/factories/`).send({
      factory: 1
    });
  };

  selectFacilityPopupShown = () => {
    this.setState({
      selectFacilityPopupShown: true,
    });
  }

  hideFacilityPopupShown = () => {
    this.setState({
      selectFacilityPopupShown: false,
    });
  }

  checkDistributionCenter = () => {
    const { distributionCenter } = this.state;

    if (distributionCenter > 0) {
      this.showChangeLocationAlert();
    } else {
      this.openDistributionCenter();
    }
  }

  openDistributionCenter = () => {
    const { distribution, players, distributionCenterId } = this.state;
    const { currentRound, rounds } = this.props;

    const round = rounds.find(i => Number(i.number) === Number(currentRound));
    const roundId = round ? Number(round.id) : 0;
    const userId = Number(Auth.getUserId());
    const teamId = Number(Auth.getTeamId());
    const player = players.find(i => Number(i.user.id) === userId);
    const playerId = player ? Number(player.id) : 0;

    if (distribution) {
      this.setState({
        openingDistributionCenter: true,
        showChangeLocationAlert: false,
      });

      if (distributionCenterId > 0) {
        patchRequest(`${process.env.REACT_APP_API_URL}v2/distributions/team-centers/${distributionCenterId}/`)
          .send({
            distribution_center: distribution.id,
          })
          .then(res => {
            this.setState({
              movingDistributionCenter: true,
              activeDistributionCenter: 0,
              distribution: null,
              leadTimes: [],
              leadTimesLoaded: false,
              openingDistributionCenter: false,
            }, () => {
              this.fetchData();
            });
          })
          .catch(err => { });
      } else {
        postRequest(`${process.env.REACT_APP_API_URL}v2/distributions/team-centers/`)
          .send({
            distribution_center: distribution.id,
            round: roundId,
            team: teamId,
            player: playerId,
          })
          .then(res => {
            this.setState({
              activeDistributionCenter: 0,
              distribution: null,
              leadTimes: [],
              leadTimesLoaded: false,
              openingDistributionCenter: false,
            }, () => {
              this.fetchData();
            });
          })
          .catch(err => { });
      }
    }
  }

  deleteDistributionCenter = () => {
    const { distributionCenterId } = this.state;

    this.setState({
      openingDistributionCenter: true,
      showDeselectLocationAlert: false,
      canSelectDistributionCenters: false
    });
    deleteRequest(`${process.env.REACT_APP_API_URL}v2/distributions/team-centers/${distributionCenterId}`)
      .then(res => {
        this.setState({
          activeDistributionCenter: 0,
          distribution: null,
          leadTimes: [],
          leadTimesLoaded: false,
          openingDistributionCenter: false,
        }, () => {
          this.fetchData();
        });
      })
      .catch(err => { });
  }

  onCreateFactory = () => {
    const { tourMode } = this.props;

    if (tourMode === true) {
      return;
    }

    this.setState({
      loadingFactory: true,
      selectFacilityPopupShown: false,
    });

    this.createFactory()
      .then(res => {
        this.showSuccessMessage((
          <Fragment>
            <b>Facility Selected Successfully</b><br />
            Note: This is the only production facility available and you need it to manufacture units.
          </Fragment>
        ));
        incrementUnacceptedDecisions("operations");
        this.setState(
          {
            loadingFactory: false
          },
          () => {
            this.fetchData();
          }
        );
      })
      .catch(err => {
        logError(err, "OperationsDecisions", "onCreateFactory");
      });
  };

  onRemoveOperation = (e, product_id, callback) => {
    e.preventDefault();

    getRequest(`${process.env.REACT_APP_API_URL}team/product_manufactures/`)
      .then(res => {
        const obj = res.body.find(i => i.product === product_id);

        if (!obj) {
          return;
        }

        deleteRequest(
          `${process.env.REACT_APP_API_URL}team/product_manufactures/${obj.id}/`
        )
          .then(res => {
            decrementUnacceptedDecisions("operations");
            this.fetchData();
            if (callback) {
              callback();
            }
          })
          .catch(err => {
            logError(err, "OperationsDecisions", "onRemoveOperation");
          });
      })
      .catch(err => {
        logError(err, "OperationsDecisions", "onRemoveOperation");
      });
  };

  render() {
    const showActionButtons = this.showActionButtons;
    const {
      total_spending,
      products,
      isOwnRole,
      loaded,
      submission_data,
      submitDecisionsLoading,
      factory_ppe,
      ppe_costs,
      loadingFactory,
      currentRound,
      rounds,
      original_machines_costs,
      production_costs,
      cash_payments_prior_round_purchases,
      capital_exp_sales,
      facility_costs,
      overall_machine_utilization,
      factories,
      selectFacilityPopupShown,
      facilityPopup,
      showDistributionCenters,
      canSelectDistributionCenters,
      activeDistributionCenter,
      distribution,
      leadTimes,
      leadTimesLoaded,
      tooltip1,
      openingDistributionCenter,
      distributionCenter,
      cash_payment_for_distribution_center,
      distributionCentersInfo,
      distributionCenterPPE,
      tooltipCustomerName,
      tooltipCustomerDemand,
      showChangeLocationAlert,
      movingDistributionCenter,
      isPreChecked,
      team_machines,
      successMessage,
      isInfoAlertVisible,
      infoAlertTitle,
      infoAlertText,
      selectDistributionCenterFacilityPopup,
      showDeselectLocationAlert
    } = this.state;
    const { tourMode, location, router, currentRound: round, roundInUrl } = this.props;
    const machineUtilityFormatted = decimalsRound(
      overall_machine_utilization * 100,
      0
    );
    const temporaryUser = Auth.getTemporaryUser();
    const showCustomerTooltip = tooltipCustomerName !== null && tooltipCustomerDemand !== null;

    console.log('activeDistributionCenter', activeDistributionCenter);
    console.log('canSelectDistributionCenters', canSelectDistributionCenters);

    return (
      <Styled.BodyWrapper>
        {isInfoAlertVisible && (
          <DecisionsAlert
            type="info"
            title={infoAlertTitle}
            message={infoAlertText}
            buttonText="Done"
            onHide={this.hideInfoAlert}
          />
        )}
        <SweetAlert
          show={showChangeLocationAlert}
          title="Change location?"
          text="You have already opened a distribution center. Continue changing to the new location?"
          confirmButtonText="Yes, Change Location"
          onConfirm={this.openDistributionCenter}
          cancelButtonText="No, Keep Current Location"
          onCancel={this.hideChangeLocationAlert}
          showCancelButton={true}
        />
        <SweetAlert
          show={showDeselectLocationAlert}
          title="Are You Sure?"
          text="By choosing this option, you are deselecting the previously selected distribution center."
          confirmButtonText="Yes, Change Location"
          onConfirm={this.deleteDistributionCenter}
          cancelButtonText="No, Keep Current Location"
          onCancel={this.hideDeselectLocationAlert}
          showCancelButton={true}
        />
        <LastStepModal
          location={location}
          router={router}
          url={`/decisions/operations?round=${round}`}
        />
        <Styled.TitleWrapper>
          <Styled.Title id="product-marketing-decisions-title">
            Operations
            {isOwnRole && !temporaryUser && <RoleButtons type="operations" />}
          </Styled.Title>
          {showActionButtons === true && loaded === true && !temporaryUser && (
            <SubmitDecisionsButton
              id="operations-decision-submit-decisions"
              tooltipPlacement="bottom"
              data={submission_data.op}
              isLoading={submitDecisionsLoading}
              onClick={this.submitDecisions}
              buttonComponent={Styled.SubmitDecisionButton}
              isPreChecked={isPreChecked}
            />
          )}
        </Styled.TitleWrapper>
        {showActionButtons === true && !temporaryUser && !leadTimesLoaded && (
          <ButtonsGroup
            factoryPpe={factory_ppe}
            ppeCosts={ppe_costs}
            loadingFactory={loadingFactory}
            onCreateFactory={this.selectFacilityPopupShown}
            tourMode={tourMode}
            reloadData={this.fetchData}
            currentRound={currentRound}
            rounds={rounds}
            products={products}
            onRemoveOperation={this.onRemoveOperation}
            factories={factories}
            team_machines={team_machines}
            teamId={Teams.currentTeam().id}
            showDistributionCenters={this.showDistributionCenters}
            showSuccessMessage={this.showSuccessMessage}
            roundInUrl={roundInUrl}
          />
        )}
        {successMessage && <SuccessAlert
          message={successMessage}
        />}
        {leadTimesLoaded && (
          <Styled.PreDescription>
            Use the map and the table below as helpful sources to evaluate how effective
            it is to open a distribution center at the suggested location. Shorter lead
            time will allow your product to speed up delivery times, operate with a smaller
            inventory to meet customer demands, and make it easier to make accurate demand
            planning. Shorter lead time means higher revenue!
          </Styled.PreDescription>
        )}
        {loaded === true && (
          <Styled.BlocksRow>
            {(selectFacilityPopupShown || showDistributionCenters) && (
              <Styled.WhiteBlock
                width="500px"
                mapOverlay={selectFacilityPopupShown || showDistributionCenters}
                innerRef={this.setPopupRef}
              >
                <Styled.GoogleMap>
                  <img src={MapImage} alt="map" />

                  {factories.length === 0 && (
                    <Styled.MapIcon isFixed={true} x={429} y={143}>
                      <img src={MapIcon1} alt="map icon" />
                    </Styled.MapIcon>
                  )}

                  {factories.length > 0 && distributionCenter !== 1 && (
                    <Styled.MapIcon isFixed={true} x={338} y={135}>
                      <img src={MapIcon3} alt="map icon" />
                    </Styled.MapIcon>
                  )}
                  {factories.length > 0 && distributionCenter === 1 && (
                    <Styled.MapIcon isFixed={true} x={338} y={135}>
                      <img src={MapIcon6} alt="map icon" />
                    </Styled.MapIcon>
                  )}

                  {factories.length > 0 && distributionCenter !== 2 && (
                    <Styled.MapIcon isFixed={true} x={275} y={208}>
                      <img src={MapIcon4} alt="map icon" />
                    </Styled.MapIcon>
                  )}
                  {factories.length > 0 && distributionCenter === 2 && (
                    <Styled.MapIcon isFixed={true} x={275} y={208}>
                      <img src={MapIcon7} alt="map icon" />
                    </Styled.MapIcon>
                  )}

                  {factories.length > 0 && distributionCenter !== 3 && (
                    <Styled.MapIcon isFixed={true} x={111} y={189}>
                      <img src={MapIcon5} alt="map icon" />
                    </Styled.MapIcon>
                  )}
                  {factories.length > 0 && distributionCenter === 3 && (
                    <Styled.MapIcon isFixed={true} x={111} y={189}>
                      <img src={MapIcon8} alt="map icon" />
                    </Styled.MapIcon>
                  )}
                </Styled.GoogleMap>
              </Styled.WhiteBlock>
            )}
            <Styled.WhiteBlock width="500px">
              {canSelectDistributionCenters && (
                <Styled.TopBanner>Open a distribution center</Styled.TopBanner>
              )}
              {movingDistributionCenter && (
                <Styled.TopBanner>Moving distribution center...</Styled.TopBanner>
              )}
              <Styled.GoogleMap>
                {/*<GoogleMapReact
                  bootstrapURLKeys={{
                    key: process.env.REACT_APP_GOOGLE_MAP_API,
                  }}
                  defaultCenter={{
                    lat: 39.8097,
                    lng: -98.5556,
                  }}
                  defaultZoom={3}
                />*/}
                <img src={MapImage} alt="map" onClick={(canSelectDistributionCenters && activeDistributionCenter) || selectDistributionCenterFacilityPopup > 0 ? this.unselectDistributionCenter : null} />

                <Styled.MapDot
                  x={321}
                  y={229}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(1)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  1
                </Styled.MapDot>
                <Styled.MapDot
                  x={257}
                  y={232}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(2)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  2
                </Styled.MapDot>
                <Styled.MapDot
                  x={65}
                  y={107}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(3)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  3
                </Styled.MapDot>
                <Styled.MapDot
                  x={359}
                  y={113}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(4)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  4
                </Styled.MapDot>
                <Styled.MapDot
                  x={30}
                  y={170}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(5)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  5
                </Styled.MapDot>
                <Styled.MapDot
                  x={250}
                  y={202}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(6)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  6
                </Styled.MapDot>
                <Styled.MapDot
                  x={241}
                  y={160}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(7)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  7
                </Styled.MapDot>
                <Styled.MapDot
                  x={283}
                  y={177}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(8)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  8
                </Styled.MapDot>
                <Styled.MapDot
                  x={171}
                  y={174}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(9)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  9
                </Styled.MapDot>
                <Styled.MapDot
                  x={311}
                  y={103}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(10)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  10
                </Styled.MapDot>
                <Styled.MapDot
                  x={414}
                  y={109}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(11)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  11
                </Styled.MapDot>
                <Styled.MapDot
                  x={149}
                  y={226}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(12)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  12
                </Styled.MapDot>
                <Styled.MapDot
                  x={345}
                  y={172}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(13)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  13
                </Styled.MapDot>
                <Styled.MapDot
                  x={303}
                  y={196}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(14)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  14
                </Styled.MapDot>

                <Styled.Tooltip1
                  show={showCustomerTooltip}
                  top={showCustomerTooltip ? tooltipsPositions[tooltipCustomerName][1] : 0}
                  left={showCustomerTooltip ? tooltipsPositions[tooltipCustomerName][0] : 0}
                >
                  <Styled.TooltipTitle>
                    <span>{showCustomerTooltip ? tooltipCustomerName : ''}</span>
                    {showCustomerTooltip ? customersLocations[tooltipCustomerName] : ''}
                  </Styled.TooltipTitle>
                  <Styled.TooltipCost background="rgba(0, 27, 43, 0.02)">
                    Customer Name: <span>{showCustomerTooltip ? tooltipCustomerName : ''}</span>
                    <Styled.TooltipSpace />
                    Demand: <span>{showCustomerTooltip ? tooltipCustomerDemand : ''} units</span>
                  </Styled.TooltipCost>
                </Styled.Tooltip1>

                {factories.length > 0 && (
                  <Styled.MapIcon
                    x={417}
                    y={146}
                    onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showTooltip1}
                    onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideTooltip1}
                    onClick={distributionCenter && canSelectDistributionCenters && activeDistributionCenter === 0 ? () => this.showSelectDistributionCenterFacilityPopup() : null}
                  >
                    <img src={MapIcon2} alt="map icon facilities" />
                  </Styled.MapIcon>
                )}

                {factories.length > 0 && !canSelectDistributionCenters && !leadTimesLoaded && (
                  <Styled.Tooltip1 show={tooltip1} top={100} left={165}>
                    <Styled.TooltipTitle>
                      <img src={MapHoverIcon1} alt="map icon" />
                      Newark, NJ
                    </Styled.TooltipTitle>
                    <Styled.TooltipImage>
                      <img src={TooltipImage1} alt="tooltip" />
                    </Styled.TooltipImage>
                    <Styled.TooltipCost>
                      Cost: <span>$1.00M</span>
                    </Styled.TooltipCost>
                  </Styled.Tooltip1>
                )}

                {factories.length > 0 && canSelectDistributionCenters && distributionCenter !== 1 && (
                  <Styled.MapIcon x={338} y={135} onClick={activeDistributionCenter === 0 && !selectDistributionCenterFacilityPopup ? () => this.selectDistributionCenter(1) : null}>
                    <img src={MapIcon3} alt="map icon select-center-yellow" />
                  </Styled.MapIcon>
                )}

                {factories.length > 0 && canSelectDistributionCenters && distributionCenter !== 1 && (
                  <Styled.Tooltip1 show={activeDistributionCenter === 1} top={55} left={80}>
                    <Styled.TooltipTitle background="#fbedd5">
                      <img src={MapHoverIcon2} alt="map icon" />
                      {distribution ? distribution.location : ''}
                    </Styled.TooltipTitle>
                    <Styled.TooltipCost>
                      Cost: <span>${distribution ? (distribution.cost / 1e6).toFixed(2) : ''}M</span>
                      <Styled.TooltipSpace />
                      Major transportation hub
                      <Styled.TooltipSpace />
                      Sustainability program
                    </Styled.TooltipCost>
                    <Styled.TooltipButtonRow>
                      <Styled.TooltipButton onClick={this.calculateDistance}>Calculate Distance</Styled.TooltipButton>
                    </Styled.TooltipButtonRow>
                  </Styled.Tooltip1>
                )}

                {factories.length > 0 && canSelectDistributionCenters && distributionCenter !== 2 && (
                  <Styled.MapIcon x={275} y={208} onClick={activeDistributionCenter === 0 && !selectDistributionCenterFacilityPopup ? () => this.selectDistributionCenter(2) : null}>
                    <img src={MapIcon4} alt="map icon select-center-purple" />
                  </Styled.MapIcon>
                )}

                {factories.length > 0 && canSelectDistributionCenters && distributionCenter !== 2 && (
                  <Styled.Tooltip1 show={activeDistributionCenter === 2} top={10} left={175}>
                    <Styled.TooltipTitle background="#eae4f9">
                      <img src={MapHoverIcon3} alt="map icon" />
                      {distribution ? distribution.location : ''}
                    </Styled.TooltipTitle>
                    <Styled.TooltipCost>
                      Cost: <span>${distribution ? (distribution.cost / 1e6).toFixed(2) : ''}M</span>
                      <Styled.TooltipSpace />
                      Major transportation hub
                      <Styled.TooltipSpace />
                      Sustainability program
                    </Styled.TooltipCost>
                    <Styled.TooltipButtonRow>
                      <Styled.TooltipButton onClick={this.calculateDistance}>Calculate Distance</Styled.TooltipButton>
                    </Styled.TooltipButtonRow>
                  </Styled.Tooltip1>
                )}

                {factories.length > 0 && canSelectDistributionCenters && distributionCenter !== 3 && (
                  <Styled.MapIcon x={111} y={189} onClick={activeDistributionCenter === 0 && !selectDistributionCenterFacilityPopup ? () => this.selectDistributionCenter(3) : null}>
                    <img src={MapIcon5} alt="map icon select-center-green" />
                  </Styled.MapIcon>
                )}

                {factories.length > 0 && canSelectDistributionCenters && distributionCenter !== 3 && (
                  <Styled.Tooltip1 show={activeDistributionCenter === 3} top={105} left={155}>
                    <Styled.TooltipTitle background="#d7f0f2">
                      <img src={MapHoverIcon4} alt="map icon" />
                      {distribution ? distribution.location : ''}
                    </Styled.TooltipTitle>
                    <Styled.TooltipCost>
                      Cost: <span>${distribution ? (distribution.cost / 1e6).toFixed(2) : ''}M</span>
                      <Styled.TooltipSpace />
                      Major transportation hub
                      <Styled.TooltipSpace />
                      Sustainability program
                    </Styled.TooltipCost>
                    <Styled.TooltipButtonRow>
                      <Styled.TooltipButton onClick={this.calculateDistance}>Calculate Distance</Styled.TooltipButton>
                    </Styled.TooltipButtonRow>
                  </Styled.Tooltip1>
                )}

                {canSelectDistributionCenters && distributionCenter && (
                  <Styled.Tooltip1 show={selectDistributionCenterFacilityPopup} top={105} left={155}>
                    <Styled.TooltipTitle background="#FBD8D8">
                      <img src={MapHoverIcon1} alt="map icon" />
                      Newark, NJ
                    </Styled.TooltipTitle>
                    <Styled.TooltipButtonRow>
                      <Styled.TooltipButton onClick={this.showDeselectLocationAlert}>Select</Styled.TooltipButton>
                    </Styled.TooltipButtonRow>
                  </Styled.Tooltip1>
                )}

                {leadTimesLoaded && activeDistributionCenter === 1 && (
                  <Styled.MapIcon x={40} y={114} width={385} height={131}>
                    <img src={MapLines1} alt="map lines" />
                  </Styled.MapIcon>
                )}
                {((leadTimesLoaded && activeDistributionCenter === 1) || (!leadTimesLoaded && distributionCenter === 1)) && (
                  <Styled.MapIcon x={338} y={135}>
                    <img src={MapIcon6} alt="map icon selected-center-yellow" />
                  </Styled.MapIcon>
                )}

                {leadTimesLoaded && activeDistributionCenter === 2 && (
                  <Styled.MapIcon x={40} y={114} width={385} height={131}>
                    <img src={MapLines2} alt="map lines" />
                  </Styled.MapIcon>
                )}
                {((leadTimesLoaded && activeDistributionCenter === 2) || (!leadTimesLoaded && distributionCenter === 2)) && (
                  <Styled.MapIcon x={275} y={208}>
                    <img src={MapIcon7} alt="map icon selected-center-purple" />
                  </Styled.MapIcon>
                )}

                {leadTimesLoaded && activeDistributionCenter === 3 && (
                  <Styled.MapIcon x={40} y={114} width={385} height={131}>
                    <img src={MapLines3} alt="map lines" />
                  </Styled.MapIcon>
                )}
                {((leadTimesLoaded && activeDistributionCenter === 3) || (!leadTimesLoaded && distributionCenter === 3)) && (
                  <Styled.MapIcon x={111} y={189}>
                    <img src={MapIcon8} alt="map icon selected-center-green" />
                  </Styled.MapIcon>
                )}
              </Styled.GoogleMap>
              <Styled.MapDetails>
                <Styled.MapDetailsTitle margin="0">
                  <Styled.MapDetailsTitleCheckbox src={SmallCheckboxActive} alt="small checkbox" />
                  Facility
                  <Styled.HelpIcon src={IconTableHelp} onClick={() => this.showInfoAlert('Facility')} />
                </Styled.MapDetailsTitle>
                <Styled.MapDetailsTitle>
                  {factories.length === 0 && '-'}
                  {factories.length > 0 && <img src={MapIcon2} alt="map icon" />}
                </Styled.MapDetailsTitle>
                <Styled.MapDetailsTitle>
                  <Styled.MapDetailsTitleCheckbox src={distributionCenter ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  Distribution Center
                  <Styled.HelpIcon src={IconTableHelp} onClick={() => this.showInfoAlert('Distribution Center')} />
                </Styled.MapDetailsTitle>
                <Styled.MapDetailsTitle>
                  {distributionCenter === 0 && '-'}
                  {distributionCenter === 1 && <img src={MapIcon6} alt="map icon" />}
                  {distributionCenter === 2 && <img src={MapIcon7} alt="map icon" />}
                  {distributionCenter === 3 && <img src={MapIcon8} alt="map icon" />}
                </Styled.MapDetailsTitle>
              </Styled.MapDetails>
            </Styled.WhiteBlock>
            {leadTimesLoaded && (
              <Styled.WhiteBlock autoWidth={true} padding="24px">
                <Styled.DistributionTitle>
                  {activeDistributionCenter === 1 && (
                    <img src={MapIcon6} alt="icon" />
                  )}
                  {activeDistributionCenter === 2 && (
                    <img src={MapIcon7} alt="icon" />
                  )}
                  {activeDistributionCenter === 3 && (
                    <img src={MapIcon8} alt="icon" />
                  )}
                  <div>{distribution ? distribution.name : ''}</div>
                </Styled.DistributionTitle>
                <Styled.DistributionTableRow marginTop={12}>
                  <Styled.DistributionTableCell isHeader={true}>Customer</Styled.DistributionTableCell>
                  <Styled.DistributionTableCell isHeader={true}>Lead Time <span>(h)</span></Styled.DistributionTableCell>
                  <Styled.DistributionTableCell isHeader={true}>Transport <span>($)</span></Styled.DistributionTableCell>
                </Styled.DistributionTableRow>
                {leadTimes.map(leadTime => (
                  <Styled.DistributionTableRow key={`distribution-table-row-${leadTime.id}`}>
                    <Styled.DistributionTableCell>{leadTime.customer}</Styled.DistributionTableCell>
                    <Styled.DistributionTableCell>{Number(leadTime.avg_time.toFixed(2))}</Styled.DistributionTableCell>
                    <Styled.DistributionTableCell>{Number(leadTime.shipping_cost.toFixed(0))}</Styled.DistributionTableCell>
                  </Styled.DistributionTableRow>
                ))}
                <Styled.DistributionButtons>
                  <Styled.DistributionCancelButton onClick={this.cancelDistributionCenter}>Cancel</Styled.DistributionCancelButton>
                  <Styled.DistributionSubmitButton onClick={openingDistributionCenter ? null : this.checkDistributionCenter} disabled={openingDistributionCenter}>
                    {openingDistributionCenter ? 'Loading...' : 'Open Distribution Center'}
                  </Styled.DistributionSubmitButton>
                </Styled.DistributionButtons>
                <Styled.DistributionInfo>
                  <span>*</span> You can only open 1 distribution center
                </Styled.DistributionInfo>
              </Styled.WhiteBlock>
            )}
            {!leadTimesLoaded && (
              <Styled.WhiteBlock autoWidth={true} padding="24px">
                <TotalProductionCost
                  cash_payment_for_distribution_center={cash_payment_for_distribution_center}
                  total_spending={total_spending}
                  capital_expenditures={this.capitalExpenditures}
                  human_utility={this.humanUtility}
                  machine_utility={this.machineUtility}
                  products={products}
                  machines_costs={original_machines_costs}
                  production_costs={production_costs}
                  cash_payments_prior_round_purchases={
                    cash_payments_prior_round_purchases
                  }
                  capital_exp_sales={capital_exp_sales}
                  facility_costs={facility_costs}
                  distributionCentersInfo={distributionCentersInfo}
                  distributionCenter={distributionCenter}
                  distributionCenterPPE={distributionCenterPPE}
                />
                <InHouseProduction
                  products={products}
                  showActionButtons={showActionButtons}
                />
                <Styled.Chart.Row width="auto">
                  Machine Utilization
                  <Styled.HelpIcon src={IconTableHelp} onClick={() => this.showInfoAlert('Machine Utilization')} />
                  <Styled.PercentAmount>
                    {machineUtilityFormatted}%
                  </Styled.PercentAmount>
                </Styled.Chart.Row>
              </Styled.WhiteBlock>
            )}
          </Styled.BlocksRow>
        )}
        {loaded === false && <Loader type="ball-scale-ripple" active />}
        <SelectFacilityPopup
          show={selectFacilityPopupShown}
          facilityPopup={facilityPopup}
          action={this.onCreateFactory}
          close={this.hideFacilityPopupShown}
        />
        <DistributionCentersPopup
          show={showDistributionCenters}
          facilityPopup={facilityPopup}
          action={this.canSelectDistributionCenters}
          close={this.hideDistributionCenters}
        />
      </Styled.BodyWrapper>
    );
  }
}

export default view(OperationsDecisions);



// WEBPACK FOOTER //
// ./src/containers/operations-decisions.js